import { Address } from './address';

export class CountryAddressFormatRequest {
  public Addresses: Address[];
}

